import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import axios from "axios";
import cookie from "react-cookies";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import $ from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig, frontURL } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  CompanyID,
  isEmpty,
  isSingleSelect,
  isValidPrice,
  isMultiSelect,
  uploadFile,
  removeFile,
  generateSlug,
  showPriceValue,
  showDateTime,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";
var module = "products";
var moduleName = "Product";
var modulePath = "/clientpanel/sell-vouchers";
const defaultTerms =
  "<ol><li>Voucher is valid for retail store redemption.</li><li>The voucher will be valid till consumed.</li> <li>Once sold, vouchers are non-refundable and cannot be exchanged.</li><li>Voucher is not transferrable, cash redeemable and not replaceable.</li><li>Voucher is to be redeemed at only the participating outlets and presented to outlet staff before ordering.</li><li>Voucher is not to be used in conjunction with other promotions, discounts, offers, vouchers and privileges.</li><li>All vouchers can be used multiple times in full or in partial.</li><li>Brand reserves the right to amend the terms & conditions as necessary, without prior notice.</li><li>Please show this E-Voucher on your handheld devices upon payment. You need not print this E-Voucher for redemption.</li></ol>";
class Form extends Component {
  constructor(props) {
    super(props);
    const ProName = this.props.location.state?.title || "";
    const ProDescription = this.props.location.state?.description || "";
    this.state = {
      editID: this.props.params?.EditID || "",
      pageloading: false,
      clientdata: {
        productOutletID: [],
        productCategoryID: "",
        productName: ProName,
        productAliasName: "",
        productSKU: "",
        productslug: "",
        productVoucherType: "",
        productVoucherBonusAmount: "",
        productShortDescription: "",
        productLongDescription: ProDescription,
        productTermsandConditions: defaultTerms,
        productPrice: "",
        productCost: "",
        productStatus: [],
        productVoucherExpiryDays: "",
        productTagInfo: "",
        productThumbnail: "",
        productLargeImage: "",
        productBuyRefer: false,
        productInfluencerCommission: "",
        productFreeProduct: false,
        productRecomented: false,
        productFreeProductQuantity: "",
        productSequence: "",
        socialanalytics: [],
        productSocialanalytics: [""],
        productWelcomeVoucher: false,
        giftProduct: "",
        productHide: false,
        action: "add",
      },
      btndisabled: false,
      loading: true,
      formpost: [],
      companyDetail: [],
      giftProductList: [],
      /* outlet_List: [],
      companyCatList: [],
      settingsDetails: [], */
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.loadSettings();
    this.loadOutlet();
    this.comapanyCatlist();
    this.getsocialSettings();
    this.loadproductList();

    if (this.state.editID !== "") {
      var params = {
        url: `${apiUrl}${module}/details/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          var productStatus = result.productStatus === "A" ? "Active" : "Inactive";
          var product_Status =
            result.productStatus !== "" && result.productStatus !== null
              ? {
                  label: productStatus,
                  value: result.productStatus,
                }
              : "";
          var productVoucherType = result.productVoucherType === "F" ? "Product Voucher" : "Cash Voucher";
          var vouchertype =
            result.productVoucherType !== "" && result.productVoucherType !== null
              ? {
                  label: productVoucherType,
                  value: result.productVoucherType,
                }
              : "";

          var productSocialanalytics = result.productSocialanalytics !== "" && result.productSocialanalytics !== null ? JSON.parse(result.productSocialanalytics) : [""];
          const productThumbnail = result?.productThumbnail || '';
          const productLargeImage = result?.productLargeImage || '';
          var clientupdatedata = {
            productOutletID: result.productOutletID.length > 0 ? result.productoutletList : [],
            productCategoryID: result.productCategoryDisplay.length > 0 ? result.productCategoryDisplay[0] : "",
            productName: result.productName,
            productAliasName: result.productAliasName,
            productSKU: result.productSKU,
            productVoucherType: vouchertype,
            productVoucherBonusAmount: result.productVoucherBonusAmount || "",
            productShortDescription: result.productShortDescription,
            productLongDescription: result.productLongDescription,
            productTermsandConditions: result.productTermsandConditions !== null ? result.productTermsandConditions : "",
            productPrice: result.productPrice,
            productCost: result.productCost || "",
            productVoucherExpiryDays: result?.productVoucherExpiryDays || 0,
            productTagInfo: result?.productTagInfo || "",
            productThumbnail: productThumbnail !== "" && productThumbnail !== null ? productThumbnail : "",
            productLargeImage: productLargeImage !== "" && productLargeImage !== null ? productLargeImage : "",
            productBuyRefer: result.productBuyRefer === "1" ? true : false,
            productFreeProduct: result?.productFreeProduct || false,
            productRecomented: result?.productRecomented || false,
            productFreeProductQuantity: result.productFreeProductQuantity,
            productSequence: result.productSequence,
            productInfluencerCommission: result.productInfluencerCommission || "",
            productslug: result.productslug,
            socialanalytics: [],
            productSocialanalytics: productSocialanalytics.length > 0 ? productSocialanalytics : [""],
            productWelcomeVoucher: result.productWelcomeVoucher || false,
            giftProduct: result.giftProduct || "",
            productHide: result.productHide || false,
            productStatus: product_Status,
            action: "edit",
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid Product", "error");
        }
      });
    }
  }

  loadSettings() {
    var urlShringTxt = apiUrl + "company/getSettings/" + CompanyID();
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ settingsDetails: res.data.result });
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  loadOutlet() {
    var urlShringTxt = apiUrl + "outlet/dropdown?company_id=" + CompanyID();
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ outlet_List: res.data.result });
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  comapanyCatlist() {
    var urlShringTxt = apiUrl + "company/categoryList?company_id=" + CompanyID();
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ companyCatList: res.data.result });
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  getsocialSettings() {
    var urlShringTxt = apiUrl + "company/getSettings/" + CompanyID();
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          var companySocialAnalytics = res.data.result?.companySocialAnalytics ? res.data.result?.companySocialAnalytics.split(",") : [];
          this.setState(
            update(this.state, {
              clientdata: { socialanalytics: { $set: companySocialAnalytics } },
            }),
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  loadproductList() {
    var urlShringTxt = apiUrl + "products/dropdownlist?productType=7";
    if (this.state.editID !== "") {
      urlShringTxt += "&ignoreProdduct=" + this.state.editID;
    }
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ giftProductList: res.data.result }, () => {
            this.setState({ giftProductList: res.data.result });
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  fieldChange = (field, value) => {
    this.setState(update(this.state, { clientdata: { [field]: { $set: value } } }), function () {
      if (field === "productOutletID") {
      }
    });
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;
    var socialanalytics = [];
    if (postData.productSocialanalytics !== "") {
      postData.productSocialanalytics.map((item) => {
        if (item !== "") {
          socialanalytics.push(item);
        }
        return "";
      });
    }
    var productOutletID = [];
    if (postData.productOutletID.length > 0) {
      postData.productOutletID.map((item) => {
        productOutletID.push(item.value);
        return "";
      });
    }
    const editorContent = $("#editorContent").val();
    const editorContent1 = $("#editorContent1").val();
    const editorContent2 = $("#editorContent2").val();
    var postObject = {
      productType: "7",
      productName: postData.productName,
      productAliasName: postData.productAliasName,
      productSKU: postData.productSKU,
      productShortDescription: editorContent,
      productLongDescription: editorContent1,
      productTermsandConditions: editorContent2,
      productVoucherType: postData.productVoucherType?.value || "",
      productVoucherBonusAmount: parseFloat(postData.productVoucherBonusAmount),
      productStatus: postData.productStatus?.value || "A",
      productPrice: parseFloat(postData.productPrice),
      productCost: parseFloat(postData.productCost),
      productOutletID: productOutletID.length > 0 ? productOutletID.join(",") : "",
      productCategoryID: Object.keys(postData.productCategoryID).length > 0 ? postData.productCategoryID.value : "",
      productVoucherExpiryDays: postData.productVoucherExpiryDays || 0,
      productTagInfo: postData.productTagInfo || "",
      productThumbnail: postData.productThumbnail,
      productLargeImage: postData.productLargeImage,
      productBuyRefer: postData.productBuyRefer === true ? "1" : "0",
      productFreeProduct: postData.productFreeProduct,
      productRecomented: postData?.productRecomented || false,
      productFreeProductQuantity: postData.productFreeProductQuantity,
      productSequence: postData.productSequence,
      productInfluencerCommission: postData?.productInfluencerCommission || null,
      productSocialanalytics: socialanalytics !== "" ? JSON.stringify(socialanalytics) : "",
      productWelcomeVoucher: postData.productWelcomeVoucher,
      giftProduct: postData.giftProduct?.value || null,
      productHide: postData.productHide,
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"sell-vouchers"} />
          <div className="layout-page">
            <Topmenu />
            <ToastContainer />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.clientdata}
                  editID={this.state.editID}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  sateValChange={this.sateValChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  outlet_List={this.state.outlet_List}
                  companyCatList={this.state.companyCatList}
                  settingsDetails={this.state.settingsDetails}
                  giftProductList={this.state.giftProductList}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          500,
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { productOutletID, productCategoryID, productName, productSKU, productPrice, productStatus } = props.fields;

  return {
    fields: ["productOutletID", "productCategoryID", "productName", "productSKU", "productPrice", "productStatus"],

    validations: {
      productOutletID: [[isMultiSelect, productOutletID]],
      productCategoryID: [[isSingleSelect, productCategoryID]],
      productName: [[isEmpty, productName]],
      productSKU: [[isEmpty, productSKU]],
      productPrice: [
        [isEmpty, productPrice],
        [isValidPrice, productPrice],
      ],
      productStatus: [[isSingleSelect, productStatus]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showList: false,
      customerkeywords: "",
      from_amount: "",
      to_amount: "",
      start_date: "",
      end_date: "",
      searchCustomerList: [],
      customerIDs: [],
      assignedStarted: false,
      selectedOutlet: "",
    };
  }

  handleChangeText(name, e) {
    this.setState({ [name]: e.target.value });
  }
  handleChangeDate(name, date) {
    this.setState({ [name]: date });
  }
  searchList() {
    let params = `productID=${this.props.editID}`;
    let error = 0;
    if (this.state.customerkeywords !== "") {
      if (params !== "") {
        params += `&`;
      }
      params += `customerkeywords=${this.state.customerkeywords}`;
      error++;
    }
    if (this.state.from_amount !== "") {
      if (params !== "") {
        params += `&`;
      }
      params += `from_amount=${this.state.from_amount}`;
      error++;
    }
    if (this.state.to_amount !== "") {
      if (params !== "") {
        params += `&`;
      }
      params += `to_amount=${this.state.to_amount}`;
      error++;
    }
    if (this.state.start_date !== "" && this.state.start_date !== null) {
      if (params !== "") {
        params += `&`;
      }
      params += `start_date=${moment(this.state.start_date).format("Y-MM-DD")}`;
      error++;
    }
    if (this.state.end_date !== "" && this.state.end_date !== null) {
      if (params !== "") {
        params += `&`;
      }
      params += `end_date=${moment(this.state.end_date).format("Y-MM-DD")}`;
      error++;
    }
    if (error > 0) {
      showLoader("searchCustomer");
      var urlShringTxt = `${apiUrl}customer/customerlistforproducts?${params}`;
      axios
        .get(urlShringTxt, clientheaderconfig)
        .then((res) => {
          if (res.data.status === "success") {
            this.setState({ searchCustomerList: res.data.result });
          }
          this.setState({ showList: true });
          hideLoader("searchCustomer");
        })
        .catch((error) => {
          hideLoader("searchCustomer");
          this.setState({ showList: true, searchCustomerList: [] });
          console.error("Error fetching data:", error);
        });
    } else {
      showAlert("Error", "Please select any one filter", "error", "No");
    }
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  setContent(fieldName, value) {
    this.props.onChange(fieldName, value);
  }
  handleChangeCheck(name, value) {
    this.props.onChange(name, value);
  }
  myFilter(elm) {
    return elm != null && elm !== false && elm !== "";
  }

  async uplaodFiles(imageType) {
    try {
      this.props.sateValChange("btndisabled", true);
      showLoader(`ImageDetails${imageType}`);
      showLoader(`ImageContainer${imageType}`);
      var imagefile = document.querySelector("#" + imageType);
      const file = imagefile.files[0];
      var fileDetail = await uploadFile(file, "products", "client", "epicpay");
      if (fileDetail.status === "ok") {
        this.props.onChange(imageType, fileDetail.url);
      }
      hideLoader(`ImageContainer${imageType}`);
      hideLoader(`ImageDetails${imageType}`);
      $("#" + imageType).val("");
      this.props.sateValChange("btndisabled", false);
    } catch (e) {
      hideLoader("ImageContainer");
      hideLoader("ImageDetails");
      $("#" + imageType).val("");
      this.props.sateValChange("btndisabled", false);
    }
  }
  async removeImage(fileNamme, imageType) {
    showLoader(`ImageDetails${imageType}`, "class");
    var fileDetail = await removeFile(fileNamme, "client", "epicpay");
    if (fileDetail.status === "ok") {
      hideLoader(`ImageDetails${imageType}`, "class");
      this.props.onChange(imageType, "");
    }
  }
  copyLink(itemproductslug) {
    toast.success("Link Copied Success", { autoClose: 1000 });
    navigator.clipboard.writeText(itemproductslug);
  }

  handleChangeSocial(addIndex, e) {
    var updproductSocialanalytics = [];
    if (this.props.fields.productSocialanalytics !== "") {
      this.props.fields.productSocialanalytics.map((item, index) => {
        if (index === addIndex) {
          updproductSocialanalytics.push(e.target.value);
        } else {
          updproductSocialanalytics.push(item);
        }
        return "";
      });
    }
    this.props.onChange("productSocialanalytics", updproductSocialanalytics);
  }

  addsocialshare() {
    var socialanalytics = this.props.fields.productSocialanalytics;
    if (socialanalytics !== "") {
      socialanalytics.push("");
    } else {
      socialanalytics = [];
      socialanalytics.push("");
    }

    this.props.onChange("productSocialanalytics", socialanalytics);
  }
  removesocialshare(removeIndex) {
    var updsocialanalytics = [];
    if (this.props.fields.productSocialanalytics !== "") {
      this.props.fields.productSocialanalytics.map((item, index) => {
        if (index !== removeIndex) {
          updsocialanalytics.push(item);
        }
        return "";
      });
    }

    this.props.onChange("productSocialanalytics", updsocialanalytics);
  }
  handleSelectChange_(selectedOutlet) {
    this.setState({ selectedOutlet: selectedOutlet });
  }
  handleChangeCheckBox(customerID) {
    let customerIDList = this.state.customerIDs;
    if (customerIDList.indexOf(customerID) >= 0) {
      customerIDList.splice(customerIDList.indexOf(customerID), 1);
    } else {
      customerIDList.push(customerID);
    }
    this.setState({ customerIDs: customerIDList });
  }

  confirmAssignedVoucherList = async () => {
    const customerIDs = this.state.customerIDs;
    let selectedOutlet = this.state.selectedOutlet;
    if (this.props.outlet_List.length === 1) {
      selectedOutlet = this.props.outlet_List[0];
    }
    if (selectedOutlet === "") {
      showAlert("Error", "Please select any one outlet", "error", "No");
      return false;
    }

    if (customerIDs.length > 0) {
      if (this.state.assignedStarted === false) {
        this.setState({ assignedStarted: true });
        showLoader("assignVoucher");
        await Promise.all(
          customerIDs.map(async (customerID) => {
            const postObject = {
              QRType: "Assigned",
              transactionMode: "Assigned",
              billAmount: "",
              voucherID: this.props.editID,
              customerID: customerID,
              outletID: selectedOutlet?.value,
            };

            await axios
              .post(apiUrl + "merchantQR/generateMerchantQR", postObject, {
                headers: {
                  Authorization: `Bearer ${cookie.load("clientAccessToken")}`,
                },
              })
              .then((res) => {
                if (res.data.status === "ok") {
                  this.confirmVoucher(customerID, res.data.QRCode, selectedOutlet?.value);
                }
              })
              .catch((e) => {
                console.error("Error fetching data:", e);
              });
          }),
        );
        hideLoader("assignVoucher");
        showAlert("Success", "Voucher assigned successfully", "success", "No");
        this.setState({ customerIDs: [], assignedStarted: true });
        this.searchList();
      }
    } else {
      showAlert("Error", "Please select any one customer", "error", "No");
    }
  };

  confirmVoucher(customerID, QRCode, outletID) {
    const postObject = {
      QRCode: QRCode,
      customerID: customerID,
      outletID: outletID,
    };

    axios
      .post(apiUrl + "merchant/redeemQrcode", postObject, {
        headers: {
          Authorization: `Bearer ${cookie.load("clientAccessToken")}`,
        },
      })
      .then((res) => {})
      .catch((e) => {
        console.error("Error fetching data:", e);
      });
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgOutlet, errMsgCompanyCatId, errMsgProName, errMsgproductSKU, errMsgStatus, errMsgProPrice;

    if ($validation.productOutletID.error.reason !== undefined) {
      errMsgOutlet = $validation.productOutletID.show && <span className="error">{$validation.productOutletID.error.reason}</span>;
    }
    if ($validation.productCategoryID.error.reason !== undefined) {
      errMsgCompanyCatId = $validation.productCategoryID.show && <span className="error">{$validation.productCategoryID.error.reason}</span>;
    }
    if ($validation.productName.error.reason !== undefined) {
      errMsgProName = $validation.productName.show && <span className="error">{$validation.productName.error.reason}</span>;
    }
    if ($validation.productSKU.error.reason !== undefined) {
      errMsgproductSKU = $validation.productSKU.show && <span className="error">{$validation.productSKU.error.reason}</span>;
    }
    if ($validation.productPrice.error.reason !== undefined) {
      errMsgProPrice = $validation.productPrice.show && <span className="error">{$validation.productPrice.error.reason}</span>;
    }
    if ($validation.productStatus.error.reason !== undefined) {
      errMsgStatus = $validation.productStatus.show && <span className="error">{$validation.productStatus.error.reason}</span>;
    }
    const companyAllowAssignVoucher = cookie.load("companyAllowAssignVoucher") ?? false;

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="row g-3">
          <div className="accordion mt-3 accordion-header-primary" id="accordionStyle1">
            <div className="accordion-item active">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-3" aria-expanded="true">
                  General Info
                </button>
              </h2>
              <div id="accordionStyle1-3" className="accordion-collapse collapse show  mt-3" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className={errMsgOutlet !== "" && errMsgOutlet !== false && errMsgOutlet !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productOutletID}
                          onChange={this.handleSelectChange.bind(this, "productOutletID")}
                          placeholder={"Select Outlet"}
                          options={this.props.outlet_List}
                          isMulti
                          isClearable={true}
                        />
                        <label className="select-box-label">
                          Outlet<span className="error">*</span>
                        </label>
                        {errMsgOutlet}
                      </div>
                    </div>
                    <div className={errMsgCompanyCatId !== "" && errMsgCompanyCatId !== false && errMsgCompanyCatId !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productCategoryID}
                          onChange={this.handleSelectChange.bind(this, "productCategoryID")}
                          placeholder={"Select Category"}
                          options={this.props.companyCatList}
                          isClearable={true}
                        />
                        <label className="select-box-label">
                          Company Category<span className="error">*</span>
                        </label>
                        {errMsgCompanyCatId}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={errMsgProName !== "" && errMsgProName !== false && errMsgProName !== undefined ? "form-control is-invalid" : "form-control"}
                          name="productName"
                          value={fields.productName}
                          {...$field("productName", (e) => onChange("productName", e.target.value))}
                        />
                        <label htmlFor="productName">
                          Voucher Name <span className="error">*</span>
                        </label>
                        {errMsgProName}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productAliasName"
                          value={fields.productAliasName}
                          {...$field("productAliasName", (e) => onChange("productAliasName", e.target.value))}
                        />
                        <label htmlFor="productAliasName">Alias Name</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={errMsgproductSKU !== "" && errMsgproductSKU !== false && errMsgproductSKU !== undefined ? "form-control is-invalid" : "form-control"}
                          name="productSKU"
                          value={fields.productSKU}
                          {...$field("productSKU", (e) => onChange("productSKU", e.target.value))}
                        />
                        <label htmlFor="productSKU">
                          productSKU <span className="error">*</span>
                        </label>
                        {errMsgproductSKU}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={errMsgProPrice !== "" && errMsgProPrice !== false && errMsgProPrice !== undefined ? "form-control is-invalid" : "form-control"}
                          name="productPrice"
                          value={fields.productPrice}
                          {...$field("productPrice", (e) => onChange("productPrice", e.target.value))}
                        />
                        <label htmlFor="productPrice">
                          Product Price / Offer Price <span className="error">*</span>
                        </label>
                        {errMsgProPrice}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input type="text" className="form-control" name="productCost" value={fields.productCost} {...$field("productCost", (e) => onChange("productCost", e.target.value))} />
                        <label htmlFor="productCost">Product Original Price</label>
                      </div>
                    </div>

                    <div className={errMsgCompanyCatId !== "" && errMsgCompanyCatId !== false && errMsgCompanyCatId !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productVoucherType}
                          onChange={this.handleSelectChange.bind(this, "productVoucherType")}
                          placeholder={"Select Voucher Type"}
                          options={[
                            { value: "F", label: "Product Voucher" },
                            { value: "C", label: "Cash Voucher" },
                          ]}
                          isClearable={true}
                        />
                        <label className="select-box-label">
                          Voucher Type<span className="error">*</span>
                        </label>
                        {errMsgCompanyCatId}
                      </div>
                    </div>
                    {fields.productVoucherType?.value === "C" && (
                      <>
                        {this.props.settingsDetails?.companyBonusType === "1" && (
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline mb-4">
                              <input
                                type="text"
                                className="form-control"
                                name="productVoucherBonusAmount"
                                value={fields.productVoucherBonusAmount}
                                {...$field("productVoucherBonusAmount", (e) => onChange("productVoucherBonusAmount", e.target.value))}
                              />
                              <label htmlFor="productVoucherBonusAmount">Bonus Amount</label>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productTagInfo"
                          value={fields.productTagInfo}
                          {...$field("productTagInfo", (e) => onChange("productTagInfo", e.target.value))}
                        />
                        <label htmlFor="productTagInfo">Tag Info</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.giftProduct}
                          onChange={this.handleSelectChange.bind(this, "giftProduct")}
                          placeholder={"Select Gift Voucher"}
                          options={this.props.giftProductList}
                          isClearable={true}
                        />
                        <label className="select-box-label">Gift Voucher</label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productVoucherExpiryDays"
                          value={fields.productVoucherExpiryDays}
                          {...$field("productVoucherExpiryDays", (e) => onChange("productVoucherExpiryDays", e.target.value))}
                        />
                        <label htmlFor="productVoucherExpiryDays">Voucher Expiry Days</label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChangeCheck.bind(this, "productBuyRefer")}
                          checked={fields.productBuyRefer}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Applicable Influencer Commission</span>
                      </div>
                    </div>
                    {fields.productBuyRefer === true && (
                      <div className="col-md-2">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="productInfluencerCommission"
                            value={fields.productInfluencerCommission}
                            {...$field("productInfluencerCommission", (e) => onChange("productInfluencerCommission", e.target.value))}
                          />
                          <label htmlFor="productInfluencerCommission">Commission Percentage</label>
                        </div>
                      </div>
                    )}

                    <div className="col-md-2">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChangeCheck.bind(this, "productFreeProduct")}
                          checked={fields.productFreeProduct}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Free Voucher</span>
                      </div>
                    </div>
                    {fields.productFreeProduct === true && (
                      <div className="col-md-2">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="productInfluencerCommission"
                            value={fields.productFreeProductQuantity}
                            {...$field("productFreeProductQuantity", (e) => onChange("productFreeProductQuantity", e.target.value))}
                          />
                          <label htmlFor="productFreeProductQuantity">Maximum Free Voucher</label>
                        </div>
                      </div>
                    )}
                    <div className="col-md-2">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChangeCheck.bind(this, "productRecomented")}
                          checked={fields.productRecomented}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Highlight Voucher</span>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChangeCheck.bind(this, "productWelcomeVoucher")}
                          checked={fields.productWelcomeVoucher}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Welcome Bonus</span>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChangeCheck.bind(this, "productHide")}
                          checked={fields.productHide}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Hide From Public</span>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <label>Short Description</label>
                      <Editor IDName={"editorContent"} data={fields.productShortDescription} />
                    </div>
                    <div className="col-md-12">
                      <label>Long Description</label>
                      <Editor IDName={"editorContent1"} data={fields.productLongDescription} />
                    </div>
                    <div className="col-md-12">
                      <label>Terms and Conditions</label>
                      <Editor IDName={"editorContent2"} data={fields.productTermsandConditions} />
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mt-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productInfluencerCommission"
                          value={fields.productSequence}
                          {...$field("productSequence", (e) => onChange("productSequence", e.target.value))}
                        />
                        <label htmlFor="productSequence">Sorting</label>
                      </div>
                    </div>
                    <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                      <br></br>
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productStatus}
                          onChange={this.handleSelectChange.bind(this, "productStatus")}
                          placeholder="Select Status"
                          options={[
                            { value: "A", label: "Active" },
                            { value: "I", label: "Inactive" },
                          ]}
                          isClearable={true}
                        />
                        <label className="select-box-label">
                          Status<span className="error">*</span>
                        </label>
                        {errMsgStatus}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <div className="mb-3" id="ImageContainerproductThumbnail">
                          <label htmlFor="formFile" className="form-label">
                            Thumbnail Image
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            id="productThumbnail"
                            onChange={(event) => {
                              this.uplaodFiles("productThumbnail", event);
                              return false;
                            }}
                          />
                          For Recommendation Size : <b>280px X 160px</b>
                          <br />
                          For Crop Image :{" "}
                          <b>
                            <a href="https://imageresizer.com/crop-image" target="_blank" rel="noreferrer">
                              click here
                            </a>
                          </b>
                        </div>
                      </div>
                      {fields.productThumbnail !== "" && (
                        <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                          <div className="dz-details" id="ImageDetailsproductThumbnail">
                            <div className="dz-thumbnail">
                              <img alt="" src={fields.productThumbnail} />
                            </div>
                          </div>
                          <a className="dz-remove" href="/" onClick={this.removeImage.bind(this, fields.productThumbnail, "productThumbnail")}>
                            Remove file
                          </a>
                        </div>
                      )}
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <div className="mb-3" id="ImageContainerproductLargeImage">
                          <label htmlFor="formFile" className="form-label">
                            Thumbnail Image
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            id="productLargeImage"
                            onChange={(event) => {
                              this.uplaodFiles("productLargeImage", event);
                              return false;
                            }}
                          />
                          For Recommendation Size : <b>280px X 160px</b>
                          <br />
                          For Crop Image :{" "}
                          <b>
                            <a href="https://imageresizer.com/crop-image" target="_blank">
                              click here
                            </a>
                          </b>
                        </div>
                      </div>
                      {console.log(fields.productLargeImage, 'fields.productLargeImage')}
                      {fields.productLargeImage !== "" && (
                        <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                          <div className="dz-details" id="ImageDetailsproductLargeImage">
                            <div className="dz-thumbnail">
                              <img alt="" src={fields.productLargeImage} />
                            </div>
                          </div>
                          <a className="dz-remove" href={void 0} onClick={this.removeImage.bind(this, fields.productLargeImage, "productLargeImage")}>
                            Remove file
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-5" aria-expanded="true">
                  Generate Unique Links
                </button>
              </h2>
              <div id="accordionStyle1-5" className="accordion-collapse collapse  mt-3" data-bs-parent="#accordionStyle5">
                <div className="accordion-body">
                  <div className="row g-3">
                    {fields.socialanalytics.length > 0 &&
                      fields.socialanalytics.map((item, index) => {
                        var productslugName = this.props.editID !== "" ? this.props.fields.productslug : generateSlug(fields.productName);
                        var displayproductslug = frontURL + "buy-vouchers/" + productslugName + "/share/" + item;
                        return (
                          <div className="row g-3" key={index}>
                            <div className="col-md-3">
                              <h5 className="mb-0 mt-3">{item}</h5>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-4">
                                <div className="input-group input-group-merge">
                                  <div className="form-floating form-floating-outline">
                                    <input type="text" className="form-control" id={`link_${index}`} readOnly value={displayproductslug} aria-describedby={`link_${index}`} />
                                    <label htmlFor={`link_${index}`}>Link</label>
                                  </div>
                                  <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, displayproductslug)}>
                                    <i className="mdi mdi-content-copy"></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="mt-3">
                                {(fields.productSocialanalytics === "" || Object.keys(fields.productSocialanalytics).length === 0) && parseInt(index) + 1 === fields.socialanalytics.length && (
                                  <span className="act-plus-icon" onClick={this.addsocialshare.bind(this)}>
                                    <i className="mdi mdi-plus-circle-outline"></i>
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}

                    {fields.productSocialanalytics !== "" &&
                      fields.productSocialanalytics.map((item, index) => {
                        return (
                          <div className="row g-3" key={index}>
                            <div className="col-md-3">
                              <div className="mb-4">
                                <div className="input-group input-group-merge">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id={`link_${index}`}
                                      value={item}
                                      onChange={this.handleChangeSocial.bind(this, index)}
                                      aria-describedby={`link_${index}`}
                                    />
                                    <label htmlFor={`link_${index}`}>Name</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-4">
                                <div className="input-group input-group-merge">
                                  <div className="form-floating form-floating-outline">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id={`link_${index}`}
                                      readOnly
                                      value={item !== "" ? frontURL + "buy-vouchers/" + this.props.fields.productslug + "/share/" + item : ""}
                                      aria-describedby={`link_${index}`}
                                    />
                                    <label htmlFor={`link_${index}`}>Link</label>
                                  </div>
                                  <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, frontURL + "buy-vouchers/" + this.props.fields.productslug + "/share/" + item)}>
                                    <i className="mdi mdi-content-copy"></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="mt-3">
                                {fields.productSocialanalytics.length > 1 && (
                                  <span className="act-minus-icon" onClick={this.removesocialshare.bind(this, index)}>
                                    <i className="mdi mdi-minus-circle-outline"></i>
                                  </span>
                                )}
                                {fields.productSocialanalytics.length - 1 === index && (
                                  <span className="act-plus-icon" onClick={this.addsocialshare.bind(this)}>
                                    <i className="mdi mdi-plus-circle-outline"></i>
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
            {Boolean(companyAllowAssignVoucher) === true && (
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button type="button" className="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-6" aria-expanded="true">
                    Allow to Assign Customer
                  </button>
                </h2>
                <div id="accordionStyle1-6" className="accordion-collapse collapse  mt-3" data-bs-parent="#accordionStyle6">
                  <div className="accordion-body">
                    <div className="row g-3">
                      <div className="col-md-4 pro-filter-text">
                        <div className="form-floating form-floating-outline mb-4">
                          <input type="text" className="form-control" name="name" onChange={this.handleChangeText.bind(this, "customerkeywords")} value={this.state.customerkeywords} />
                          <label htmlFor="name">Search Customer</label>
                        </div>
                      </div>
                      <div className="col-md-2 pro-filter-outlet">
                        <div className="form-floating form-floating-outline mb-4 custm-date-box">
                          <DatePicker
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            selected={this.state.start_date}
                            dateFormat="dd-MM-yyyy"
                            onChange={this.handleChangeDate.bind(this, "start_date")}
                          />
                          <label htmlFor="name" className="select-box-label">
                            Visit From Date
                          </label>
                        </div>
                      </div>
                      <div className="col-md-2 pro-filter-outlet">
                        <div className="form-floating form-floating-outline mb-4 custm-date-box">
                          <DatePicker
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            selected={this.state.end_date}
                            dateFormat="dd-MM-yyyy"
                            onChange={this.handleChangeDate.bind(this, "end_date")}
                          />
                          <label htmlFor="name" className="select-box-label">
                            Visit To Date
                          </label>
                        </div>
                      </div>
                      <div className="col-md-2 pro-filter-search">
                        <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                          <input type="text" className="form-control" onChange={this.handleChangeText.bind(this, "from_amount")} value={this.state.from_amount} />
                          <label htmlFor="name">Spent Amount From</label>
                        </div>
                      </div>
                      <div className="col-md-2 pro-filter-text">
                        <div className="form-floating form-floating-outline mb-4">
                          <input type="text" className="form-control" onChange={this.handleChangeText.bind(this, "to_amount")} value={this.state.to_amount} />
                          <label htmlFor="name">Spent Amount To</label>
                        </div>
                      </div>
                      <div className="col-md-1 mt-2 pro-filter-sbtbtn">
                        <button type="button" className="btn btn-primary me-sm-3 me-1 waves-effect waves-light " id="searchCustomer" onClick={this.searchList.bind(this)}>
                          Search
                        </button>
                      </div>

                      <div className="col-md-1 mt-2 pro-filter-refbtn">
                        <button
                          type="reset"
                          className="btn btn-label-secondary waves-effect"
                          /*  onClick={this.resetSearch.bind(this)} */
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                    {this.state.showList === true && (
                      <div>
                        <div className="col-lg-12 col-md-12">
                          <div className="row">
                            <div className="col-lg-6 col-md-6"></div>
                            <div className="col-lg-4 col-md-4">
                              {this.props.outlet_List.length > 1 && (
                                <div className="form-floating form-floating-outline custm-select-box mb-4">
                                  <Select
                                    value={this.state.selectedOutlet}
                                    onChange={this.handleSelectChange_.bind(this)}
                                    placeholder={"Select Outlet"}
                                    options={this.props.outlet_List}
                                    isClearable={true}
                                  />
                                  <label className="select-box-label">
                                    Outlet<span className="error">*</span>
                                  </label>
                                </div>
                              )}
                            </div>
                            <div className="col-lg-2 col-md-2 text-end">
                              <button type="button" className="btn btn-primary me-sm-3 me-1 waves-effect waves-light" onClick={this.confirmAssignedVoucherList.bind(this)} id="assignVoucher">
                                Assign
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="table-responsive text-nowrap">
                          <table className="table">
                            <thead>
                              <tr>
                                <th></th>
                                <th>Customer Name</th>
                                <th>Customer Email</th>
                                <th>Customer Phone</th>
                                <th>Total Spent</th>
                                <th>Buy / Assigned Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.loading === true ? (
                                <tr>
                                  <td colSpan={7} align="center">
                                    <div className="spinner-border spinner-border-lg text-primary" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                    </div>
                                  </td>
                                </tr>
                              ) : this.state.searchCustomerList.length > 0 ? (
                                this.state.searchCustomerList.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>
                                        <div className="form-check form-check-inline mt-3">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`cust${index}`}
                                            checked={this.state.customerIDs.indexOf(item.transCustomerID) >= 0 ? true : false}
                                            onChange={this.handleChangeCheckBox.bind(this, item.transCustomerID)}
                                          />
                                          <label className="form-check-label" htmlFor={`cust${index}`}>
                                            &nbsp;
                                          </label>
                                        </div>
                                      </td>
                                      <td>
                                        <strong>{item.customerName}</strong>
                                      </td>
                                      <td>{item.customerEmail}</td>
                                      <td>{item.customerPhone}</td>
                                      <td>{showPriceValue(item.totalQRUsedAmount)}</td>
                                      <td>
                                        {item.customerTrans.length > 0
                                          ? item.customerTrans.map((item, index) => {
                                              return (
                                                <div key={index}>
                                                  <p>
                                                    <b>Date:</b>
                                                    {showDateTime(item.createdAt)} <b>Type:</b>
                                                    {item.transQRType} <b>Transaction ID:</b>
                                                    {item.transactionID}
                                                  </p>
                                                </div>
                                              );
                                            })
                                          : ""}
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td className="text-center" colSpan={6}>
                                    No Customer Found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="pt-1 pb-4 pr-2 text-end" style={{ paddingRight: "20px" }}>
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
